import React, { useEffect, useState } from 'react';

import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerWorkspace from '../../../../components/ContainerConteudo';
import OffCanvas from '../../../../components/OffCanvas';
import { getNumerosGerais } from '../../../../services/statistics/numerosGerais';
import { formatDateSimp } from '../../../../utils/functions';
import subAbas from '../subabas';
// const PresentationContainer = styled.div`
//   height: 20%;
//   margin-bottom: 1rem;
// `;

// const TituloContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: flex-start;
//   margin-bottom: 0.9rem;
//   color: ${({ theme }) => theme.colors.tituloColor};
//   font-size: 1.3rem;
// `;

// const CardContainer = styled.div`
//   display: flex;

//   flex-wrap: wrap;
//   gap: 30px;

//   & > div {
//     flex: 1 1 calc(15% - 30px);
//   }

//   @media (max-width: 768px) {
//     & > div {
//       flex: 1 1 calc(50% - 30px);
//     }
//   }

//   @media (max-width: 480px) {
//     & > div {
//       flex: 1 1 100%;
//     }
//   }
// `;

// const InformesContainer = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

// const CardInformesContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   gap: 15px;
// `;

const HomeInicio: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [data, setData] = useState<any[]>([]);
  const fetchData = async () => {
    try {
      const numerosGeraisData = await getNumerosGerais();
      setData(numerosGeraisData);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const iconesInformes = [
  //   { value: 1, label: 'Ajuda', icone: <RiQuestionLine /> },
  //   { value: 2, label: 'Atenção', icone: <RiAlertLine /> },
  //   { value: 3, label: 'Atualização', icone: <LuRefreshCcw /> },
  //   { value: 4, label: 'Ideia', icone: <RiLightbulbLine /> },
  //   { value: 5, label: 'Lupa', icone: <RiFileInfoLine /> },
  //   { value: 6, label: 'Mensagem', icone: <RiMessage2Line /> },
  //   { value: 7, label: 'Relógio', icone: <RiAlarmLine /> },
  // ];

  // const getIcon = (value: number) => {
  //   const item = iconesInformes.find((icon) => icon.value === value);
  //   return item ? item.icone : <RiQuestionLine />;
  // };

  const [selectedInforme, setSelectedInforme] = useState<any>(null);
  const [showOffCanvas, setShowOffCanvas] = useState(false);

  // const handleShowOffCanvas = (informe: any) => {
  //   setSelectedInforme(informe);
  //   setShowOffCanvas(true);
  // };

  const handleHideOffCanvas = () => {
    setShowOffCanvas(false);
    setSelectedInforme(null);
  };

  return (
    <>
      {/* Principais Números */}
      {/* <PresentationContainer>
          <TituloContainer>Principais Números</TituloContainer>

          <CardContainer theme={theme}>
            <CardNumber
              title="Produtos Farmacêuticos"
              number={String(data.produtosDaf)}
              color={theme.colors.verdegov}
              icon={<LuPill />}
              iconSize="35px"
              onClick={() => navigate('/daf/produtosdaf/produtos')}
            />

            <CardNumber
              title="Fornecedores"
              number={String(data.fornecedores)}
              color={theme.colors.amarelogov}
              icon={<CiBoxes />}
              iconSize="35px"
              onClick={() => navigate('/daf/fornecedores/fornecedores')}
            />
            <CardNumber
              title={'Processos Aquisitivos\n em andamento'}
              number={String(data.proaqs)}
              color={theme.colors.azul}
              icon={<RiGitBranchLine />}
              iconSize="35px"
              onClick={() => navigate('/daf/proaq/processos')}
            />

            <CardNumber
              title="Contratos Vigentes"
              number="-"
              color={theme.colors.roxo}
              icon={<RiContractLine />}
              iconSize="35px"
              onClick={() => navigate('#')}
            />
          </CardContainer>
        </PresentationContainer> */}

      {/* Informes */}
      {/* <InformesContainer>
          <TituloContainer>Informes</TituloContainer>
          <CardInformesContainer theme={theme}>
            {informes.filter(
              (informe) =>
                informe.statusDisplay === 1 &&
                informe.alcanceDaf !== 0 &&
                informe.alcanceDaf !== 1,
            ).length > 0 ? (
              informes
                .filter(
                  (informe) =>
                    informe.statusDisplay === 1 &&
                    informe.alcanceDaf !== 0 &&
                    informe.alcanceDaf !== 1,
                )
                .map((informe) => (
                  <CardInformes
                    key={informe.id}
                    color={theme.colors.azulgov}
                    onClick={() => handleShowOffCanvas(informe)}
                    icon={getIcon(Number(informe.imagemCard))}
                    titulo={informe.titulo}
                    data_informe={formatDateSimp(informe.dataInforme)}
                    descricao={informe.resumo}
                    iconSize="4rem"
                  />
                ))
            ) : (
              <div
                style={{
                  width: '100%',
                  textAlign: 'center',
                  color: 'blue',
                  backgroundColor: 'white',
                  padding: '10px',
                  paddingBottom: '15px',
                  borderRadius: '15px',
                }}
              >
                <span style={{ fontSize: '2rem' }}>
                  <RiThumbUpLine />
                </span>
                <br />
                Nenhum informe ativo!
              </div>
            )}
          </CardInformesContainer>
        </InformesContainer> */}
      <BarraSubAbas subAbas={subAbas} />
      <ContainerWorkspace>
        <OffCanvas
          show={showOffCanvas}
          onHide={handleHideOffCanvas}
          placement="end"
          name="Detalhes do Informe"
          style={{ width: '40%' }}
          botaoAbrir={false}
          tipoCopiar="simples"
          mostrarBotaoCopiar={false}
        >
          {selectedInforme && (
            <div style={{ padding: '20px' }}>
              <h2>{selectedInforme.titulo}</h2>
              <span>Data do Informe:</span>{' '}
              {formatDateSimp(selectedInforme.dataInforme)}
              <p>
                <br></br>
                <strong>Resumo</strong>
                <br></br> {selectedInforme.resumo}
                <br></br>
                <br></br>
                <strong>Descrição</strong>
                <br></br> {selectedInforme.descricao}
              </p>
            </div>
          )}
        </OffCanvas>
      </ContainerWorkspace>
    </>
  );
};

export default HomeInicio;
